module.exports = __webpack_public_path__ + "img/CrossModal.29947c4a.svg";